import Vue from 'vue'
import VueI18n from 'vue-i18n'
import zh from './zh'
import en from './en'

Vue.use(VueI18n)

const messages = {
  zh,
  en
}

const getLocaleFromUrl = () => {
  const urlParams = new URLSearchParams(window.location.search)
  const lang = urlParams.get('lang')
  if (lang && (lang === 'zh' || lang === 'en')) {
    return lang
  }
  return null
}

const i18n = new VueI18n({
  locale: getLocaleFromUrl() || localStorage.getItem('language') || 'zh',
  messages
})

export default i18n